import styled, { keyframes } from 'styled-components';

import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

const fadeInAnimation = keyframes`
    from { max-height: 0; }
    to { max-height: 5000px; }
`;

export const RegionElement = styled.div`
    flex-direction: column;
    flex-wrap: nowrap;
    align-items: flex-start;
    row-gap: 15px;
    display: flex;
  
    &:last-child {
        padding-bottom: 10px;
        border-bottom: 1px solid ${COLORS.GRAY_LIGHT};
    }

    @media (min-width: ${wideBreakpoints.mobile}) {
        &:last-child {
            padding-bottom: 0;
            border-bottom: none;
        }
    }
`;

export const RegionTitle = styled.span<{ isOpen: boolean }>`
    ${FONTS.XS};
    transition: color 0.2s linear;
    cursor: pointer;
    color: ${p => p.isOpen ? COLORS.Logo : COLORS.TextPrimary};
    border-bottom: 1px dashed ${p => p.isOpen ? 'transparent' : COLORS.TextPrimary};

    &:hover {
        color: ${COLORS.Logo};
        border-bottom: 1px dashed ${COLORS.Logo};
    }
`;

export const CitiesWrap = styled.div<{ isOpen: boolean }>`
    display: ${p => p.isOpen ? 'block' : 'none'};
    padding-left: 15px;
    animation-name: ${p => p.isOpen ? fadeInAnimation : ''};
    animation-duration: 0.9s;
    animation-timing-function: ease-in;
    animation-delay: 0s;
    animation-iteration-count: 1;
    animation-direction: normal;
    animation-fill-mode: both;
    animation-play-state: running;
    overflow: hidden;
`;

export const CityItem = styled.div<{ isMain: boolean }>`
    width: fit-content;
    ${p => p.isMain ? FONTS.MediumS : FONTS.XS};
    border-bottom: 1px dotted ${COLORS.TextPrimary};
    cursor: pointer;

    &:not(:last-child) {
        margin-bottom: 15px;
    }
`;
